import styled from 'styled-components';

const StyledLogoImg = styled.img`
  display: block;
  // vince l'altezza: la larghezza segue le proporzioni del logo
  height: 36px;
  width: auto;
  max-width: none;
  border: none;
  margin: 0;
  padding: 0;
`;
const LogoButton = styled.button`
  display: flex;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  &:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 3px;
  }
`;

export interface IFullscreenHeaderLogoProps {
  src: string;
  alt?: string;
  onClick?: () => void;
}

/**
 * Logo dell'header del layout fullscreen: solo immagine, ad altezza fissa.
 */
export function FullscreenHeaderLogo(props: IFullscreenHeaderLogoProps) {
  const { src, alt, onClick } = props;
  const logo = <StyledLogoImg src={src} alt={alt} />;

  if (!onClick) return logo;

  return (
    <LogoButton type="button" onClick={onClick}>
      {logo}
    </LogoButton>
  );
}
